import { ThemeFactory, Theme, DARK_THEME } from "react-ui";
import { KonturColors } from "@skbkontur/colors";

export const reactUIDarkTheme: Theme = ThemeFactory.create(
    {
        bgActive: "#5199db",
        bgDefault: KonturColors.grayscaleText,
        bgDisabled: "rgba(255, 255, 255, 0.05)",
        blinkColor: "rgba(0, 136, 255, 0.4)",
        blueLight: "#5199db",
        borderColorFocus: "#5199db",
        borderColorGrayDark: "#4D4D4D",
        borderColorGrayLight: "#4D4D4D",
        btnDefaultBg: KonturColors.grayscaleText,
        btnDefaultBgEnd: "none",
        btnDefaultBgStart: "none",
        btnDefaultHoverBg: KonturColors.grayscaleText,
        btnDefaultHoverBgEnd: "#333",
        btnDefaultHoverBgStart: "#333",
        btnDisabledBg: "rgba(255, 255, 255, 0.05)",
        btnDisabledTextColor: "#aaa",
        btnMenuArrowColor: "#666",
        btnPrimaryHoverBorderColor: "rgba(5, 60, 99, 0.7)",
        btnSuccessHoverBorderColor: "rgba(7, 73, 1, 0.7)",
        calendarCellBg: KonturColors.grayscaleText,
        calendarCellHoverBgColor: "#5199db",
        calendarCellSelectedBgColor: "#5199db",
        calendarCellTodayBorder: "1px solid #333333",
        calendarCellWeekendColor: "#FF1414",
        calendarMonthHeaderStickedBgColor: KonturColors.grayscaleText,
        calendarMonthTitleBorderBottomColor: KonturColors.grayscaleText,
        checkboxBg: "linear-gradient(#fdfdfd, #ededed) !important",
        checkboxCheckedColor: "#000",
        checkboxHoverBg: "linear-gradient(-180deg, #f2f2f2 0, #dfdfdf 100%) !important",
        checkboxShadowDisabled: "rgba(255, 255, 255, .5)",
        dateInputIconColor: "#666",
        dateInputMaskColor: "#4D4D4D",
        dateSelectMenuBg: KonturColors.grayscaleText,
        dateSelectMenuItemBgActive: "#5199db",
        dateSelectMenuItemBgDisabled: KonturColors.grayscaleText,
        dateSelectMenuItemBgSelected: "#5199db",
        dateSelectMenuItemFontSelected: "#fff",
        inputBg: "#333",
        inputColor: "#fff",
        inputTextColor: "#fff",
        linkActiveColor: "rgba(255, 255, 255, 0.66)",
        linkColor: "#fff",
        linkHoverColor: "#fff",
        loaderBg: "#333",
        loaderOpacity: "0.9",
        menuBorder: "rgba(0, 0, 0, 0)",
        menuItemHoverBg: "#0488E0",
        menuItemSelectedBg: "rgba(255, 255, 255, 0.05)",
        menuSeparatorBorderColor: "#404040",
        menuShadow: "0 0 0 1px #404040, 0 5px 20px 0 rgba(0, 0, 0, 0.4)",
        modalCloseButtonColor: "rgba(255, 255, 255, 0.5)",
        modalCloseButtonHoverColor: "rgba(255, 255, 255, 0.7)",
        modalFixedHeaderBg: KonturColors.grayscaleText,
        modalFixedHeaderShadow: "0 1px 7px #000000",
        modalFooterBg: "#272727",
        pagingDotsColor: "#A0A0A0",
        pagingForwardLinkColor: "#00A8FF",
        pagingForwardLinkDisabledColor: "#A0A0A0",
        pagingPageLinkActiveBg: "rgba(255, 255, 255, 0.06)",
        pagingPageLinkActiveColor: "#a0a0a0",
        pagingPageLinkHintColor: "rgba(160, 160, 160, 0.35)",
        pagingPageLinkHoverBg: "rgba(255, 255, 255, 0.05)",
        calendarBg: KonturColors.grayscaleText,
        pickerShadow: "0 0 0 1px #4d4d4d, 0 3px 10px 0 rgba(0, 0, 0, 0.2)",
        placeholderColor: "#aaa",
        placeholderColorLight: "#bbb",
        popupBorder: "1px solid",
        popupBorderColor: "#4D4D4D",
        popupTextColor: "#fff",
        radioBgImage: "linear-gradient(#fdfdfd, #ededed) !important",
        radioDisabledShadow: "0 0 0 1px rgba(0, 0, 0, 0.15) !important",
        radioHoverBg: "linear-gradient(-180deg, #f2f2f2 0, #dfdfdf 100%) !important",
        sidePageCloseButtonColor: "rgba(255, 255, 255, 0.5)",
        sidePageCloseButtonHoverColor: "rgba(255, 255, 255, 0.7)",
        sidePageFooterPanelBg: "#272727",
        tabColorFocus: "#5199db",
        tabColorHoverError: "#f1ac9f",
        tabColorHoverPrimary: "#84c4ee",
        tabColorHoverSuccess: "#7de849",
        tabColorHoverWarning: "#ffeec3",
        textColorDefault: "#fff",
        textareaBg: "none",
        textareaColor: "inherit",
        toastBg: "rgba(0, 0, 0, 0.8)",
        toggleFocusShadowColor: "#5199db",
        tooltipCloseBtnColor: "#808080",
        tooltipCloseBtnHoverColor: "#606060",
    },
    DARK_THEME
);
